import { useCallback, memo } from "react";
import React from "react";
import { Button} from "antd";
import { useNavigate } from "react-router-dom";
const TextLinkRenderer = (params) => {
  const { value, handleClick} = params;
  const navigate = useNavigate();
  const onLinkClick = useCallback(
    (e) => {
      e.stopPropagation();
      handleClick(params);
    },
    [handleClick, params]
  );
  const onMatchClick = useCallback(
    (e) => {
      e.stopPropagation();
      const documentId = params.data._id;
      navigate(`/matcher/${documentId}`); // Replace with your actual route for the Selecting page
    },
    [navigate, params]
  );
  return (
    <>
    <div onClick={onLinkClick} title={value}>
      {/* <Button className={`link-primary text-truncate ${styles.textLink}`}
      style={{height:"28px", marginTop:"5px"}}
      >
        Invoice
      </Button> */}
      <Button
        className="link-primary text-truncate"
        style={{height:"28px", marginTop:"5px", backgroundColor:"#0A8394", color:"white"}}
        onClick={onMatchClick}
      >
        View Match
        {/* ({params.data.matchesLength}) */}
      </Button>
    </div>
    </>
  );
};
export default memo(TextLinkRenderer);







